export default {
  watch: {
  },
  methods: {
    checkBrokerName (rule, value, cb) {
      this.debouncer1.debounce(500, function () {
        let cond = []
        cond.push({ 'field name': 'brokerShortName', operator: '=', value: [ value ] })
        this.$tango.searchBroker({ conditions: cond}).then(rep => {
          if (rep.resultCode === 0) {
            if (rep.totalCount === 0) cb()
            else {
              rep.brokerList.filter(r => {
                if (r.brokerId !== this.form.brokerId) {
                  rule.message = 'Broker short name already exists'
                  cb(new Error())
                }
              })
              cb()
            }
          }
          else {
            rule.message = 'Broker short name already exists'
            cb(new Error())
          }
        })
      }.bind(this))
    },
    checkBrokerLongName (rule, value, cb) {
      this.debouncer2.debounce(500, function () {
        let cond = []
        cond.push({ 'field name': 'brokerLongName', operator: '=', value: [ value ] })
        this.$tango.searchBroker({ conditions: cond}).then(rep => {
          if (rep.resultCode === 0) {
            if (rep.totalCount === 0) cb()
            else {
              rep.brokerList.filter(r => {
                if (r.brokerId !== this.form.brokerId) {
                  rule.message = 'Broker long name already exists'
                  cb(new Error())
                }
              })
              cb()
            }
          }
          else {
            rule.message = 'Broker long name already exists'
            cb(new Error())
          }
        })
      }.bind(this))
    },
    handleDelete: function (row) {
      let cond = {}
      if (row.children) {
        let list = []
        row.children.forEach(item => {
          list.push({
            brokerPtfId: item.brokerPtfId
          })
        })
        cond = {
          brokerId: row.brokerId,
          brokerList: list
        }
      }
      else {
        cond.brokerList = []
        cond.brokerList.push({ brokerPtfId: row.brokerPtfId })
      }

      this.$confirm('This will permanently delete the broker. Continue ?', 'Warning', {
        confirmButtonText: this.$t('OK'),
        cancelButtonText: this.$t('Cancel'),
        type: 'warning'
      }).then(() => {
        this.$tango.deleteBroker(cond).then(rep => {
          if (rep.resultCode !== 0) {
            throw new Error(this.$t('Deleted failed') + ' ' + this.$t(this.resultMessage[rep.resultCode]))
          }
          else {
            this.resetPermission()
            this.$message({
              type: 'success',
              message: this.$t('Deleted successfully')
            })
            if (cond.brokerId) {
              let route = {
                path: '/admin/broker/edit',
                params: { recordId: cond.brokerId },
                meta: { title: this.$route.meta.title }
              }
              this.$store.dispatch('tagsView/delView', route)
            }
            /*
            for(let item in cond) {
              let route = {
                path: '/admin/broker/edit',
                params: { recordId: item.brokerId },
                meta: { title: this.$route.meta.title }
              }
              this.$store.dispatch('tagsView/delView', route)
            }
            */
            this.$router.push({ path: '/next' }).then(() => { return this.$router.push({ name: 'adminBrokerList' }) }).catch(() => {})
          }
        }).catch(err => {
          // eslint-disable-next-line no-console
          console.log(err)
          this.$message({
            type: 'error',
            message: err.message
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        })
      })
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$refs.spinner.show()
          this.isReadOnly = true
          let api = this.$route.params.create ? 'createBroker' : 'updateBroker'
          this.$tango[api](this.form).then(r => {
            this.$refs.spinner.hide()
            if (r.resultCode !== 0) throw new Error(r.resultCode)
            this.$message({
              type: 'success',
              message: this.$route.params.create ? this.$t('Creation broker has been successfully completed') : this.$t('Modification broker has been successfully completed')
            })

            this.$route.params.recordLabel = r.shortName
            this.$route.params.recordId = this.form.brokerId = r.brokerId
            if (this.$route.params.create) {
              this.$route.params.create = false
              this.$route.params.recordLabel = r.shortName
              this.$store.dispatch('tagsView/addView', this.$route)
            }
            else {
              this.$store.dispatch('tagsView/updateVisitedView', this.$route)
            }
            this.resetPermission()
            this.reload()
          }).catch(err => {
            this.$refs.spinner.hide()
            this.$message({
              type: 'error',
              message: this.resultMessage[err]
            })
          })
        }
      })
    }
  }
}
